<template>
  <VouchersTableHistory class="pb-4">
    <template v-slot:actions="{ dataset }">
      <v-btn color="secondary" :data="dataset" @click="exportToExcel">
        <v-icon left>mdi-file-excel</v-icon>
        Exporter
      </v-btn>
    </template>
  </VouchersTableHistory>
</template>
<script>
import { VouchersTableHistory } from "@/components"
import { fmtCfsiData } from "@/utils/download"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { CompanyVouchersService } from "@/services";
import { toDatetime } from "@/utils/datetime";

export default {
  name: "CompanyVoucherHistoryView",
  components: { VouchersTableHistory },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset)
    },
    save() {
      CompanyVouchersService.regularize(this).then(response => {
        this.$store.commit("app/message", {
          msg: response.message,
          color: response.status
        })

      })
    },
    exportToExcel() {
      const filters = {
        search: this.$children[0]?.search || "",
        start_date: this.$children[0]?.startDate || "",
        end_date: this.$children[0]?.endDate || "",
        shop: this.$children[0]?.selectedShop || "",
      };

      CompanyVouchersService.get(this, { ...filters, limit: 100000 }).then((response) => {
        const allData = response.results;

        if (!allData.length) {
          this.$store.commit("app/message", {
            msg: this.$t("messages.warning.no_data_to_export"),
            color: "warning",
          });
          return;
        }

        const exportData = allData.map((item) => ({
          "Entreprise": item.recipient_company?.name || "N/A",
          "Véhicule": item.vehicle_detail?.registration_number || "N/A",
          "Conducteur": `${item.vehicle_detail?.driver_first_name || ""} ${item.vehicle_detail?.driver_last_name || ""}`.trim(),
          "Montant": Number(item.purchase_amount) || 0,
          "Litres": Number(item.purchase_liters) || 0,
          "Restant": Number(item.remaining_amount) || 0,
          "Date de fin": toDatetime(item.valid_until) || "N/A",
          "Site": item.company_shop?.name || "Tout le réseau",
          "Produit": item.company_product?.name || "N/A",
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Bons");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `bons_${new Date().toISOString().slice(0, 10)}.xlsx`);

        this.$store.commit("app/message", {
          msg: this.$t("Fichier Excel exporté avec succès"),
          color: "success",
        });
      });
    },
  }
}
</script>
